import React, { useEffect, useRef } from 'react'
import { useTranslate } from '@ur-solutions/react-hooks'
import {
  Dropzone,
  DropZoneArea,
  DropzoneTrigger,
  type useDropzone,
} from '@/components/ui/dropzone'
import { CloudUploadIcon } from 'lucide-react'

interface UploadDropzoneProps {
  dropzone: ReturnType<typeof useDropzone>

  /** File extension filter for the file picker dialog, e.g. ".ddd" */
  accept?: string
}

export const UploadDropzone: React.FC<UploadDropzoneProps> = ({
  dropzone,
  accept,
}) => {
  const translations = useTranslate({
    uploadFiles: 'documents.upload-files',
    dragAndDrop: 'documents.drag-and-drop-to-upload',
  })

  const areaRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!accept || !areaRef.current) return
    const input = areaRef.current.querySelector('input[type="file"]')
    if (input) input.setAttribute('accept', accept)
  }, [accept])

  return (
    <Dropzone {...dropzone}>
      <DropZoneArea ref={areaRef} onClick={e => e.stopPropagation()}>
        <DropzoneTrigger className="flex flex-col items-center gap-4 bg-transparent p-10 text-center text-sm">
          <CloudUploadIcon className="size-8" />
          <div>
            <p className="font-semibold">{translations.uploadFiles}</p>
            <p className="text-sm text-muted-foreground">
              {translations.dragAndDrop}
            </p>
          </div>
        </DropzoneTrigger>
      </DropZoneArea>
    </Dropzone>
  )
}
